import type { CommunityMemberSubscription } from "@circle-react/types/CommunityMemberSubscription";
import { Form } from "@circle-react-uikit/Form";
import { formId } from "../constants";
import { useCancelOptionsForm } from "./hooks/useCancelOptionsForm";

interface CancelOptionsFormProps {
  subscription: CommunityMemberSubscription;
}

export const CancelOptionsForm = ({ subscription }: CancelOptionsFormProps) => {
  const { cancelOptions } = useCancelOptionsForm({ subscription });

  return (
    <div className="pt-5">
      <Form.Item
        className="border-0 pt-2"
        labelClassName="text-sm font-semibold"
        name="ends_at"
        translationRoot="settings.paywalls_admin_dashboard.subscriptions.cancel_and_refund_modal.cancel_options"
        hideBorder={false}
        hideDescription
        hiddenField
        id={formId}
      >
        <Form.RadioGroup
          variant="radio"
          name="ends_at"
          options={cancelOptions}
        />
      </Form.Item>
    </div>
  );
};
